<template>
  <div class="about__container">
    <div class="about__text">

      <p>
        OOO is a design studio focused on Digital Experiences. We help startups & business to
        vision & develop their design strategy, from brand to digital products,
        defining activities, processes and visual outputs.
      </p>
      <p>
        Our industry expertise include e-learning experiences, fast fashion &
        luxury e-commerce, art & design media
      </p>
    </div>
    <div class="about__tags">
      <div class="tags__container"><div>ART DIRECTION</div></div>
      <div class="tags__container"><div>Content design</div></div>
      <div class="tags__container"><div>UX - UI</div></div>
      <div class="tags__container"><div>creative production</div></div>
      <div class="tags__container"><div>CREATIVE cODING</div></div>
      <div class="tags__container"><div>WEB DEVELOPMENT</div></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.about {
  color: white;

  &__container {
    height: 100%;
    width: 100%;
    // background: coral;
    padding-bottom: 16px;
    display: flex;
    gap: 32px;
    padding-top: 146px;
    padding-left: 33vw;
    @media screen and (max-width: 767px) {
      overflow: scroll;
      overflow-x: scroll;
      scroll-behavior: smooth;
      scroll-snap-type: x mandatory;
      -ms-scroll-snap-type: x mandatory;
      -ms-overflow-style: none;
      overflow-style: none;
      -ms-overflow-style: none; /* for Internet Explorer, Edge */
      scrollbar-width: none; /* for Firefox */
      &::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
      }
      padding-left: 0;
      padding-top: 0;
      padding-bottom: 5vh;
      height: 40vh;
    }
  }
  &__text {
    display: flex;
    height: 100%;
    width: 50%;
    flex-direction: column;
    justify-content: flex-end;
    font-family: "Lausanne";
    font-size: 1.3vw;
    @media screen and (max-width: 767px) {
      flex: 0 0 75%;
      font-size: 12px;
      // width: 80vw;
    }

    p {
      margin-top: 24px;
    }
  }
  &__tags {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    @media screen and (max-width: 767px) {
      flex: 0 0 100%;
      padding-right: 32px;
    }
    .tags__container {
      display: flex;

      div {
        font-family: "Lausanne";
        font-size: 1.3vw;
        text-transform: uppercase;
        border: 1px solid white;
        border-radius: 20px;
        padding: 4px 18px 0 18px;
        margin-top: 8px;
        @media screen and (max-width: 767px) {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
